  query getUTMReferrers(
    $clientId: ID
    $projectId: ID
    $productIds: [ID]
    $startDate: AWSDateTime
    $endDate: AWSDateTime
  ) {
    utmReferrers: SalesAnalyticsGetUTMTotals(
      startDate: $startDate
      endDate: $endDate
      clientId: $clientId
      projectId: $projectId
      productIds: $productIds
      productView: BUNDLE
    ) {
      byMedium {
        utmMedium
        quantity
        sales
      }
      byCampaign {
        utmCampaign
        quantity
        sales
      }
    }
  }